import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SystemAlerts = () => {
  const [alerts, setAlerts] = useState([
    {
      id: 1,
      type: 'error',
      title: 'Erreur de Paiement',
      message: 'Échec du traitement de 3 paiements automatiques. Intervention requise.',
      timestamp: '2025-09-06T11:45:00',
      dismissed: false
    },
    {
      id: 2,
      type: 'warning',
      title: 'Seuil de Commission Atteint',
      message: 'Le partenaire Jean Martin a atteint 90% de son seuil mensuel.',
      timestamp: '2025-09-06T10:30:00',
      dismissed: false
    },
    {
      id: 3,
      type: 'info',
      title: 'Mise à Jour Système',
      message: 'Maintenance programmée le 10/09/2025 de 02h00 à 04h00.',
      timestamp: '2025-09-06T09:15:00',
      dismissed: false
    },
    {
      id: 4,
      type: 'success',
      title: 'Sauvegarde Complétée',
      message: 'Sauvegarde automatique des données terminée avec succès.',
      timestamp: '2025-09-06T08:00:00',
      dismissed: false
    }
  ]);

  const handleDismiss = (id) => {
    setAlerts(prev => prev?.map(alert => 
      alert?.id === id ? { ...alert, dismissed: true } : alert
    ));
  };

  const handleDismissAll = () => {
    setAlerts(prev => prev?.map(alert => ({ ...alert, dismissed: true })));
  };

  const getAlertIcon = (type) => {
    switch (type) {
      case 'error': return 'AlertCircle';
      case 'warning': return 'AlertTriangle';
      case 'info': return 'Info';
      case 'success': return 'CheckCircle';
      default: return 'Bell';
    }
  };

  const getAlertColor = (type) => {
    switch (type) {
      case 'error': return 'text-error bg-error/10 border-error/20';
      case 'warning': return 'text-warning bg-warning/10 border-warning/20';
      case 'info': return 'text-accent bg-accent/10 border-accent/20';
      case 'success': return 'text-success bg-success/10 border-success/20';
      default: return 'text-muted-foreground bg-muted border-border';
    }
  };

  const formatTime = (timestamp) => {
    const now = new Date();
    const alertTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - alertTime) / (1000 * 60));
    
    if (diffInMinutes < 60) {
      return `Il y a ${diffInMinutes} min`;
    } else if (diffInMinutes < 1440) {
      const hours = Math.floor(diffInMinutes / 60);
      return `Il y a ${hours}h`;
    } else {
      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })?.format(alertTime);
    }
  };

  const activeAlerts = alerts?.filter(alert => !alert?.dismissed);

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-card-foreground mb-1">Alertes Système</h3>
          <p className="text-sm text-muted-foreground">
            {activeAlerts?.length} alerte{activeAlerts?.length !== 1 ? 's' : ''} active{activeAlerts?.length !== 1 ? 's' : ''}
          </p>
        </div>
        {activeAlerts?.length > 0 && (
          <Button variant="ghost" size="sm" onClick={handleDismissAll}>
            <Icon name="X" size={16} className="mr-2" />
            Tout ignorer
          </Button>
        )}
      </div>
      <div className="space-y-3 max-h-80 overflow-y-auto">
        {activeAlerts?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Shield" size={48} className="text-success mx-auto mb-3" />
            <p className="text-muted-foreground">Aucune alerte système</p>
            <p className="text-sm text-muted-foreground mt-1">Tous les systèmes fonctionnent normalement</p>
          </div>
        ) : (
          activeAlerts?.map((alert) => (
            <div key={alert?.id} className={`border rounded-lg p-4 ${getAlertColor(alert?.type)}`}>
              <div className="flex items-start justify-between">
                <div className="flex items-start space-x-3 flex-1">
                  <Icon name={getAlertIcon(alert?.type)} size={20} className="mt-0.5 flex-shrink-0" />
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-1">
                      <h4 className="font-medium text-sm">{alert?.title}</h4>
                      <span className="text-xs opacity-75 ml-2 flex-shrink-0">
                        {formatTime(alert?.timestamp)}
                      </span>
                    </div>
                    <p className="text-sm opacity-90 leading-relaxed">{alert?.message}</p>
                  </div>
                </div>
                <Button 
                  variant="ghost" 
                  size="sm"
                  onClick={() => handleDismiss(alert?.id)}
                  className="ml-2 flex-shrink-0 opacity-70 hover:opacity-100"
                >
                  <Icon name="X" size={14} />
                </Button>
              </div>
            </div>
          ))
        )}
      </div>
      {activeAlerts?.length > 3 && (
        <div className="mt-4 pt-4 border-t border-border">
          <Button variant="outline" fullWidth>
            Voir Toutes les Alertes
          </Button>
        </div>
      )}
    </div>
  );
};

export default SystemAlerts;